import { render, staticRenderFns } from "./IBSRegimeTaxesData.vue?vue&type=template&id=256f050a&"
import script from "./IBSRegimeTaxesData.vue?vue&type=script&lang=js&"
export * from "./IBSRegimeTaxesData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports